import { createApp, h } from 'vue';
import PrimeVue from 'primevue/config';
import DialogService from 'primevue/dialogservice';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import RoomBooking from "./vue/RoomBooking.vue";

const roomBookingApp = document.querySelector('#roomBookingApp');
if (roomBookingApp) {
    const seedData = {
        department:roomBookingApp.dataset.department,
        nearestDepartments:roomBookingApp.dataset.nearestDepartments,
        nodeId:roomBookingApp.dataset.nodeId,
        rooms:roomBookingApp.dataset.rooms,
        parentLink:roomBookingApp.dataset.parentLink,
        waitingListLink:roomBookingApp.dataset.waitingListLink,
        supportLink:roomBookingApp.dataset.supportLink,
        findOtherLink:roomBookingApp.dataset.findOtherLink
    };

    const roomBooking = createApp({
        data() { return seedData },
        render: () => h(RoomBooking)
    }, seedData);

    roomBooking.use(PrimeVue);
    roomBooking.use(DialogService);
    roomBooking.use(ConfirmationService);
    roomBooking.use(ToastService);
    roomBooking.mount(roomBookingApp);
}
